type GraphQLLikeError = {
  message?: string | undefined;
  graphQLErrors?: { message?: string | undefined }[] | undefined;
  errors?: { message?: string | undefined }[] | undefined;
};

const hasErrorShape = (error: unknown): error is GraphQLLikeError =>
  typeof error === "object" && error !== null;

/**
 * True when a query failed only because the API does not know a field yet.
 * Lets a newer UI degrade a field instead of failing the whole screen while
 * the matching API change rolls out.
 */
const isUnknownFieldError = (error: unknown): boolean => {
  if (!hasErrorShape(error)) {
    return false;
  }
  return [
    error.message,
    ...(error.graphQLErrors || []).map((graphQLError) => graphQLError?.message),
    ...(error.errors || []).map((graphQLError) => graphQLError?.message),
  ]
    .filter((message): message is string => Boolean(message))
    .some((message) => /cannot query field/i.test(message));
};

export default isUnknownFieldError;
